import { Schema } from "mongoose"
import { z } from "zod"


export const ZRBOAuthRequest = z.object({
  _id: z.string(),
  providerId: z.string(),
  codeVerifier: z.string(),
  returnTo: z.string().optional(),
  createdAt: z.date(),
  expiresAt: z.date(),
})

export type IRBOAuthRequest = z.infer<typeof ZRBOAuthRequest>

export const RBOAuthRequestSchema: Schema = new Schema(
  {
    _id: { type: String, required: true },
    providerId: { type: String, required: true, index: true },
    codeVerifier: { type: String, required: true },
    returnTo: { type: String, required: false },
    createdAt: { type: Date, required: true, default: Date.now },
    expiresAt: { type: Date, required: true },
  },
  { versionKey: false },
)

RBOAuthRequestSchema.index({ expiresAt: 1 }, { expireAfterSeconds: 0 })
